import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useUserStore = create(
  persist(
    (set) => ({
      user: null, // { id, name, email, token, ... }
      notificationCount: 0,
      sitelogo: null,
      siteColor: null,
      setUser: (userData) => set({ user: userData }),
      updateUser: (partialData) =>
        set((state) => ({
          user: { ...state.user, ...partialData },
        })),
      logout: () =>
        set({
          user: null,
          notificationCount: 0,
          sitelogo: null,
          siteColor: null,
        }),
      setNotificationCount: (count) => set({ notificationCount: count }),
      setSiteLogo: (logo) => set({ sitelogo: logo }),
      setSiteColor: (color) => set({ siteColor: color }),
    }),
    {
      name: "user-storage", // key in localStorage
    }
  )
);
